import { ReactNode } from 'react';
import HeaderBackground from '@/components/ui/header-background/header-background';
import '../../../dashboard/dashboard-reset.css';

interface LabsHeaderContainerProps {
  children: ReactNode;
  className?: string;
  minHeight?: string;
}

export function LabsHeaderContainer({ children, className = '', minHeight = 'md:min-h-[400px]' }: LabsHeaderContainerProps) {
  return (
    <div
      className={`dashboard-reset relative overflow-hidden bg-[#0a0a0a] ${minHeight} ${className}`}
      role="region"
      aria-label="Labs header"
    >
      <HeaderBackground blur={30} />
      <div className="relative z-10 mx-auto max-w-[1184px] px-5 pb-6 pt-8 md:px-8 md:pb-12 md:pt-16 lg:px-16 xl:px-24 2xl:px-32">
        {children}
      </div>
    </div>
  );
}
